export const SAVING_INDICATOR_TYPES = {
  LOADER: 'loader',
  LINE: 'line'
}
